(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('KiosksDashboards', KiosksDashboards);

    KiosksDashboards.$inject = ['$resource'];

    function KiosksDashboards($resource) {
        var resourceUrl = 'api/kiosk-dashboard/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'availableDashboard': {
                method: 'GET',
                url: 'api/kiosk-dashboard/available',
                isArray: true
            },
            'update': {method: 'PUT'},
            'deleteFromKiosk': {
                method: 'DELETE',
                url: 'api/kiosk-dashboard/delete-from-kiosk/:id/:kioskId'
            },
            'delete': {
                method: 'DELETE',
                url: 'api/kiosk-dashboard/:id'
            }
        });
    }
})();
